import * as React from "react"
import {useEffect} from "react";
import {Grid} from "@mui/material";

import {HOME_ROUTES, MARKETPLACES_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import {isSystemBusy} from "@signals";
import { TourProvider, TourTarget } from "@tour"
import { BuyBoxShare } from "./@components";
import { ReasonShare } from "./@components";
import {marketplacesLBBOverviewIsEmpty} from "./signals";
import LostBuyBoxOverviewCompetitorsTable from "./CompetitorsTable";
import LostBuyBoxOverviewTable from "./OverviewTable";
import MarketplacesLBBOverviewFilters  from "./Filters";


export default function MarketplacesLostBuyBoxOverviewPage() {

    return <PageWrapper
        head={`DIP Insight | ${MARKETPLACES_ROUTES.LBBOVERVIEW_SUBTITLE}`}
        title={MARKETPLACES_ROUTES.TITLE}
        subtitle={MARKETPLACES_ROUTES.LBBOVERVIEW_SUBTITLE}
        filters={<MarketplacesLBBOverviewFilters />}
        hasErrors={isSystemBusy.value}
        isEmpty={marketplacesLBBOverviewIsEmpty.value}
        tourPageKey="lbbOverview"
    >
        <Grid container spacing={4}>
            <Grid item xs={4} data-tour="lbb-overview-buybox-share">
                <BuyBoxShare />
            </Grid>

            <Grid item xs={4} data-tour="lbb-overview-reason-share">
                <ReasonShare />
            </Grid>

            <Grid item xs={4} data-tour="lbb-overview-competitors">
                <LostBuyBoxOverviewCompetitorsTable />
            </Grid>

            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="lbb-overview-table" height={350} />
                <LostBuyBoxOverviewTable />
            </Grid>
        </Grid>
    </PageWrapper>
}